<!-- 
    说明：秒杀课程的倒计时
    创建时间：2022/8/25
    创建者：congpeizhi
-->
<template>
    <div class="kill-layout">
        <div class="kill-date">距结束仅剩{{ restDay }}天</div>
        <div class="kill-time">
            <div class="kill-time-item">{{ restTimeH }}</div>
            <div class="kill-time-point">:</div>
            <div class="kill-time-item">{{ restTimeM }}</div>
            <div class="kill-time-point">:</div>
            <div class="kill-time-item">{{ restTimeS }}</div>
        </div>
    </div>
</template>

<script lang="ts">
import {
    defineComponent,
    ref,
    onBeforeUnmount,
    computed,
    onMounted,
    Ref,
    reactive,
} from 'vue';
import { formatMillsecond, TimeTypeObj } from '@/utils/date';
import { isIOS, osVer, compareVersion } from '@/utils/env';

const ONE_DAY_MILLISECONDS = 86400000;
export interface CountDownProps {
    endTime: number;
    intervalTime: number;
    diff: number;
}
export default defineComponent({
    name: 'CountDown',
    props: {
        endTime: {
            type: Number,
            default: +new Date(),
        },
        interval: {
            type: Number,
            default: 100,
        },
        diff: {
            // 服务器和客户端之间的误差时间
            type: Number,
            default: 0,
        },
    },
    setup(props, ctx) {
        const restDay = computed(() =>
            props.endTime - timeState.t2 > 0
                ? Math.floor((props.endTime - timeState.t2) / ONE_DAY_MILLISECONDS)
                : 0,
        );
        const restTimeH = ref('');
        const restTimeM = ref('');
        const restTimeS = ref('');
        const timer = ref<NodeJS.Timeout>();
        const timeState = reactive({
            t1: 0, // 倒计时开始时间
            c1: 0, // 递归次数
            t2: 0, // 本次递归时间
        });

        function countDownHandler() {
            // 加上误差才是真实时间
            // props.diff  server time - client time
            timeState.t2 = Date.now() + props.diff;
            const timeGap = props.endTime - timeState.t2;
            if (timeGap <= 0) {
                if (timer.value) {
                    clearTimeout(timer.value);
                    ctx.emit('end');
                }
                return;
            }
            const restTimeObj = formatMillsecond(
                props.endTime - timeState.t2 - restDay.value * ONE_DAY_MILLISECONDS,
                'obj',
            ) as TimeTypeObj;
            restTimeH.value = restTimeObj.h;
            restTimeS.value = restTimeObj.s.slice(0, 2);
            restTimeM.value = restTimeObj.m;

            // ios 13 以下机型，针对100ms级变化，在用户下拉时会产生抖动，因此将间隔提为1s
            const interval =
                isIOS && !compareVersion(osVer, '14') ? props.interval * 10 : props.interval;

            // 校准一下
            const offset = timeState.t2 - (timeState.t1 + timeState.c1 * interval);
            const nextTime = interval - offset;

            timer.value = setTimeout(countDownHandler, nextTime);
            timeState.c1 += 1;
        }

        onMounted(() => {
            timeState.t1 = Date.now();
            countDownHandler();
        });

        onBeforeUnmount(() => {
            if (timer.value) {
                clearTimeout(timer.value);
            }
        });

        return {
            restTimeH,
            restTimeM,
            restTimeS,
            restDay,
        };
    },
});
</script>

<style lang="less" scoped>
.kill-layout {
    .kill-date {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 9px;
        line-height: 11px;
        color: #ff5000;
        text-align: center;
        margin-bottom: 1px;
    }
    .kill-time {
        height: 16px;
        display: flex;
        &-item {
            width: 16px;
            height: 16px;
            background: linear-gradient(135deg, #ff8000 0%, #ff0a43 97.83%);
            border-radius: 2px;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 11px;
        }
        &-point {
            height: 16px;
            line-height: 13px;
            padding: 0 2px;
            font-size: 11px;
            color: #ff5000;
        }
    }
}
</style>
